export default __webpack_public_path__ + "static/media/background.ee6b0161.png";